<template>
  <v-data-table
    :headers="toraHeaders"
    :items="tenant.toraCredentials"
    class="elevation-1 my-7"
    :class="{ 'on-add': onAddingProcess }">
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Tora Credentials</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="accent" dark class="mb-2" v-bind="attrs" v-on="on"> New Item</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ editingItem ? "Edit" : "Create New" }} Item</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      v-model="modalPayload.environment"
                      :items="Environments"
                      menu-props="auto"
                      hide-details
                      item-text="text"
                      item-value="value"
                      label="Environment"
                      single-line></v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      hide-details="auto"
                      v-model="modalPayload.organizationSlug"
                      label="Organization Slug"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field hide-details="auto" v-model="modalPayload.clientId" label="Client ID"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      hide-details="auto"
                      v-model="modalPayload.clientSecret"
                      label="Client Secret"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions class="pr-8 pb-8">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="dialog = false"> Cancel</v-btn>
              <v-btn color="accent" @click="handleSave"> Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="deleteDialog" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="deleteDialog = false">Cancel</v-btn>
              <v-btn color="accent" @click="confirmDeleteItem">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small color="third" class="mr-2" @click="editItem(item)"> mdi-pencil</v-icon>
      <v-icon small color="primary" @click="deleteItem(item)"> mdi-delete</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import editableTableMixin from "@/views/TenantManagement/mixins/editableTableMixin";

export default {
  name: "ToraCredentials",
  mixins: [editableTableMixin],
  props: {
    tenant: {
      type: Object,
      required: true,
    },
    onAddingProcess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toraHeaders: [
        { text: "Environment", align: "start", sortable: false, value: "environment" },
        { text: "Organization Slug", value: "organizationSlug" },
        { text: "Client ID", value: "clientId" },
        { text: "Actions", value: "actions", sortable: false, align: "right" },
      ],
      modalPayload: {
        environment: "",
        organizationSlug: "",
        clientId: "",
        clientSecret: "",
      },
      dialog: false,
      deleteDialog: false,
      itemToDelete: null,
      editingItem: null,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.modalPayload = {
          environment: "",
          organizationSlug: "",
          clientId: "",
          clientSecret: "",
        };
        this.editingItem = null;
      }
    },
  },
  methods: {
    handleSave() {
      if (this.editingItem) {
        Object.assign(this.editingItem, {
          environment: this.modalPayload.environment,
          organizationSlug: this.modalPayload.organizationSlug,
          clientId: this.modalPayload.clientId,
          clientSecret: this.modalPayload.clientSecret,
        });
      } else {
        this.tenant.toraCredentials.push({
          environment: this.modalPayload.environment,
          organizationSlug: this.modalPayload.organizationSlug,
          clientId: this.modalPayload.clientId,
          clientSecret: this.modalPayload.clientSecret,
        });
      }
      this.dialog = false;
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    confirmDeleteItem() {
      const index = this.tenant.toraCredentials.indexOf(this.itemToDelete);
      if (index > -1) {
        this.tenant.toraCredentials.splice(index, 1);
      }
      this.deleteDialog = false;
      this.itemToDelete = null;
    },
    editItem(item) {
      this.modalPayload.environment = item.environment;
      this.modalPayload.organizationSlug = item.organizationSlug;
      this.modalPayload.clientId = item.clientId;
      this.modalPayload.clientSecret = item.clientSecret;
      this.editingItem = item;
      this.dialog = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
